import { TabWrap } from 'sections/TabWrap';

import { useImages } from './Images.hooks';

export function Images(): React.ReactElement {
  const { sections } = useImages();

  return <TabWrap sections={sections} />;
}
